import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';

import { ChatEventsService, ChatService, SessionStorageService } from '@shared/services';
import { ChatEvent } from '@shared/factories';

@Component({
  selector:      'chat-badge',
  templateUrl: './chat-badge.component.html',
  host: { class: 'am-flex-align gap-xs height-45 pl-xxs pr-m bg-blue b-radius-20 pointer select-none hover-bg-light-blue animate-bg',
        '[class.animate-halo-grey]': 'totalUnreadCount  > 0',
        '[class.shadow-border-s]':   'totalUnreadCount <= 0',
        '(click)': 'openChatList.emit()'
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatBadgeComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  totalUnreadCount: number;
  @Output() openChatList = new EventEmitter<void>();
  constructor(
    private sessionStorageService: SessionStorageService,
    private chatEventsService:     ChatEventsService,
    private chatService:           ChatService
  ) { }

  ngOnInit(): void {
    this.sessionStorageService.pills.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(pills => this.getTotalUnreadCount());
    this.chatEventsService.totalUnreadCount.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(count => this.totalUnreadCount = count);
    this.chatEventsService.chatEvents.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => this.eventHandler(event));
  }

  private getTotalUnreadCount(): void {
    this.chatService.getTotalUnreadCount().pipe(take(1)).subscribe();
  }

  private eventHandler(event: ChatEvent): void {
    switch (event?.type) {
      case 'seen_messages':              { this.seenMessageHandler(event); break; };
      case 'new_message':                { this.newMessageHandler(event);  break; };
      case 'bulk_message_create_result': { this.getTotalUnreadCount();     break; };
      default:                           {                                 break; };
    };
  }

  private seenMessageHandler(event: ChatEvent): void {
    this.chatEventsService.changeTotalUnreadCount(Math.max(0, +this.totalUnreadCount - event.messageIds.length));
  }

  private newMessageHandler(event: ChatEvent): void {
    if (event.channel === 'InternalLocationsChannel') this.chatEventsService.changeTotalUnreadCount(Math.max(0, +this.totalUnreadCount + 1));
  }

}
